import signalR from '../libs/signalR'
import $ from 'jquery'
import jwtStore from '@/utils/localStorageJwt'
signalR($)

const SignalRPlugin = {}
SignalRPlugin.install = function (Vue, connectionUrl) {
  if (!connectionUrl) {
    throw new Error('Connection url not provided')
  }
  Vue.prototype.$signalRConnected = false
  let signalRConnection
  let signalRHubProxy

  Vue.prototype.$configureSignalR = () => {
    signalRConnection = $.hubConnection(connectionUrl)
    signalRHubProxy = signalRConnection.createHubProxy('sidHub')

    Vue.prototype.$signalRConnection = signalRConnection
    Vue.prototype.$signalRHubProxy = signalRHubProxy
  }

  Vue.prototype.$connectSignalR = async (transactionId, system) => {
    const token = jwtStore.get(transactionId)
    signalRConnection.qs = {
      jwtIdentity: token,
      transactionId,
      system,
    }
    return signalRConnection.start()
  }

  Vue.prototype.$stopSignalR = async () => {
    return signalRConnection.stop()
  }
}

export default SignalRPlugin
